import type {InsightStatMetricDefinition} from "../base/insightStatCardFormatting";
import {OVERVIEW_STAT_METRICS} from "../crm-overview/overviewStatMetrics";

export type InsightTargetKind = "RATE" | "CUMULATIVE";
export type InsightTargetScoring = "HIGHER_IS_BETTER" | "LOWER_IS_BETTER";

export interface InsightTargetMetricDefinition extends InsightStatMetricDefinition {
    kind: InsightTargetKind;
    scoring: InsightTargetScoring;
}

const CUMULATIVE_TARGETS = new Set([
    "totalRevenue",
    "ancillaryRevenue",
    "roomNightsSold",
    "otbRoomNights",
]);

export const TARGET_METRIC_DEFINITIONS: InsightTargetMetricDefinition[] = OVERVIEW_STAT_METRICS.map(definition => ({
    ...definition,
    kind: CUMULATIVE_TARGETS.has(definition.id) ? "CUMULATIVE" : "RATE",
    scoring: definition.id === "cancellationRate" ? "LOWER_IS_BETTER" : "HIGHER_IS_BETTER",
}));

export const TARGET_METRICS_BY_ID = new Map(TARGET_METRIC_DEFINITIONS.map(definition => [definition.id, definition]));
